import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';

import AppLocale from './languages';

import Router from './router/Router';
import ErrorBoundary from './view/cockpit/ErrorBoundary';

export default function App() {
  // Redux
  const customise = useSelector((state) => state.customise);

  // Lang
  const currentAppLocale = AppLocale[customise.language];

  return (
    <ConfigProvider
      locale={currentAppLocale.antd}
      direction={customise.direction}
    >
      {/*  locale={currentAppLocale.antd} */}
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <ErrorBoundary>
          <Router />
        </ErrorBoundary>
      </IntlProvider>
    </ConfigProvider>
  );
}
